import NiceModal from "@ebay/nice-modal-react";
import { ButtonProps, Stack } from "@mui/material";
import { FC } from "react";
import { InternalButtonLink } from "../InternalButtonLink";
import { HeadingXS } from "../Typography";
import * as Styled from "./ChangePensionContribution.styled";
import { BankIdStepExtraProps } from "./ChangePensionContribution.types";

export type ChangePensionContributionProps = {
    kind: "homePage" | "detail";
    icon?: ButtonProps["startIcon"];
    disabled?: boolean;
    buttonText: string;
} & BankIdStepExtraProps;

// this component is hidden behind a feature flag GATSBY_FEATURE_IS_NEW_DPS_CONTRIBUTION_CHANGE_ENABLED
// only button rendering component
export const ChangePensionContribution: FC<ChangePensionContributionProps> = ({
    kind,
    icon,
    disabled,
    buttonText,
    ...rest // BankIdStepExtraProps
}) => {
    const handleShowStepper = () => {
        NiceModal.show("Nicemodal-ChangePensionContributionStepperModal", {
            additionalContentProps: {
                ...rest,
            },
        });
    };

    const enhancedDisabled = disabled || !rest.contractId || !rest.contractType || !rest.bankIdAuthorizationUri;

    return (
        <>
            {kind === "homePage" ? (
                <Styled.LinkButton
                    component="a"
                    disableElevation={true}
                    variant="contained"
                    startIcon={icon}
                    disabled={enhancedDisabled}
                    onClick={handleShowStepper}
                >
                    <Stack sx={{ flexGrow: 1, justifyContent: "center" }}>
                        <HeadingXS withoutScale sx={{ mb: 0, fontSize: { md: "1.4rem", xs: "1.2rem" } }}>
                            {buttonText}
                        </HeadingXS>
                    </Stack>
                </Styled.LinkButton>
            ) : (
                <InternalButtonLink variant="text" disabled={enhancedDisabled} onClick={handleShowStepper}>
                    {buttonText}
                </InternalButtonLink>
            )}
        </>
    );
};
